import LearnPageLayout from "@/components/LearnPageLayout";
import { page10 } from "./learnDataP10";

const TmsDevicesComparedPage = () => (
  <LearnPageLayout
    title={page10.title}
    description={page10.description}
    canonical={page10.canonical}
    h1={page10.h1}
    breadcrumbLabel={page10.breadcrumbLabel}
    crumbs={page10.crumbs}
    shortAnswer={page10.shortAnswer}
    keyTakeaways={page10.keyTakeaways}
    sections={page10.sections}
    faqs={page10.faqs}
    sources={page10.sources}
    schemaJson={page10.schemaJson}
    relatedLinks={page10.relatedLinks}
  />
);

export default TmsDevicesComparedPage;
